import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import type { IconName } from '@freelancer/ui/icon';
import { LinkUnderline } from '@freelancer/ui/link';
import { PictureLayout } from '@freelancer/ui/picture';
import { TagColor, TagSize } from '@freelancer/ui/tag';
import { FontWeight } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'app-freightlancer-browse-category',
  template: `
    <div class="RoleLabel">
      <fl-tag
        [color]="TagColor.SECONDARY"
        [size]="TagSize.MID"
        [fontWeight]="FontWeight.BOLD"
      >
        {{ roleLabel }}
      </fl-tag>
    </div>
    <fl-link
      class="CategoryLink"
      [link]="link"
      [display]="'block'"
      [underline]="LinkUnderline.NEVER"
      [flTrackingLabel]="trackingLabel"
    >
      <fl-card class="Card">
        <div class="Card-content">
          <fl-icon
            class="mb-xxsmall"
            [color]="IconColor.PRIMARY"
            [name]="iconName"
            [size]="IconSize.LARGE"
            [useIconFont]="true"
          />
          <h2
            class="text-body-20 font-bold mb-xxxsmall"
            [innerHTML]="heading"
          ></h2>
          <p class="text-body-12">
            {{ description }}
          </p>
        </div>
        <fl-picture
          class="Card-image"
          [src]="imageSrc"
          [layout]="PictureLayout.FIXED"
          [width]="140"
          [height]="140"
          [alt]="imageAlt"
        ></fl-picture>
      </fl-card>
    </fl-link>
  `,
  styleUrls: ['./freightlancer-browse-category.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreightlancerBrowseCategoryComponent {
  IconColor = IconColor;
  IconSize = IconSize;
  LinkUnderline = LinkUnderline;
  PictureLayout = PictureLayout;
  FontWeight = FontWeight;
  TagColor = TagColor;
  TagSize = TagSize;

  @Input({ required: true }) link: string;
  @Input({ required: true }) trackingLabel: string;
  @Input({ required: true }) roleLabel: string;
  @Input({ required: true }) iconName: IconName;
  @Input({ required: true }) heading: string;
  @Input({ required: true }) description: string;
  @Input({ required: true }) imageSrc: string;
  @Input({ required: true }) imageAlt: string;
}
